import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent  as VisualizeIcon } from "../../assets/icons/icon-visualize.svg"
import { ReactComponent  as FilterIcon } from "../../assets/icons/icon-filter.svg"
import { ReactComponent  as ActionsIcon } from "../../assets/icons/icon-actions.svg"
import { ReactComponent  as SettingsIcon } from "../../assets/icons/icon-filter-setting2.svg"
// ----------------------------------------------------------------------

//const getIcon = (name) => <Icon icon={name} width={100} height={100} />
const getIcon = (name) => <SvgIcon component={name} width={100} height={100} />

const reportSidebarConfig = [
  {
    title: 'Visualize',
    path: '#',
    icon: <VisualizeIcon />
  },
  {
    title: 'Filter',
    path: '#',
    icon: <FilterIcon />
  },
  // {
  //   title: 'Actions',
  //   path: '#',
  //   //icon: getIcon(OutlineTouchApp),
  //   icon: getIcon(ActionsIcon)
  // },
  {
    title: 'Settings',
    path: '#',
    icon: <SettingsIcon />
  },
]

export default reportSidebarConfig
